<div class="box">
    <div class="box-row header">
        <app-header-bar [title]="'licenses.title'"></app-header-bar>
    </div>

    @if(serverLicenses.length > 0) {
        <h2>{{'licenses.server' | translate}} ({{serverDependenciesCount}})</h2>
        <div class="accordion">
            @for (license of serverLicenses; track license; let i = $index) {
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#licenses-server-'+i"
                                aria-expanded="false"
                                [attr.aria-controls]="'licenses-server-'+i"
                                translate
                        >
                            {{license.name}} ({{license.dependencies.length}})
                        </button>
                    </h2>
                    <div [id]="'licenses-server-'+i" class="accordion-collapse collapse">
                        <div class="accordion-body">
                            <ul>
                                @for (dependency of license.dependencies; track dependency) {
                                    <li>
                                        {{dependency.group}}:{{dependency.name}}:{{dependency.version}}
                                        @if (dependency.licenseUrl) {
                                            (<a href="{{dependency.licenseUrl}}" target="_blank" translate>licenses.license</a>)
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    @if(clientLicenses.length > 0) {
        <h2 class="mt-4">{{'licenses.client' | translate}} ({{clientDependenciesCount}})</h2>

        <div class="accordion">
            @for (license of clientLicenses; track license; let i = $index) {
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#licenses-client-'+i"
                                aria-expanded="false"
                                [attr.aria-controls]="'licenses-client-'+i"
                                translate
                        >
                            {{license.name}} ({{license.dependencies.length}})
                        </button>
                    </h2>
                    <div [id]="'licenses-client-'+i" class="accordion-collapse collapse">
                        <div class="accordion-body">
                            <ul>
                                @for (dependency of license.dependencies; track dependency) {
                                    <li>
                                        @if (dependency.group) {
                                            {{dependency.group}}:{{dependency.name}}:{{dependency.version}}
                                        } @else {
                                            {{dependency.name}}:{{dependency.version}}
                                        }
                                        @if (dependency.licenseUrl) {
                                            (<a href="{{dependency.licenseUrl}}" target="_blank" translate>licenses.license</a>)
                                        }
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</div>
